import styled from 'styled-components';
import { FONTS, COLORS } from '@stelecom/ui-react/assets/js/constants';
import { breakpoints } from '~/src/layout/index/styled';

export const MEDIA = {
    DESKTOP: '1365px',
    TABLET: '1023px',
    LANDSCAPE_PHONE: '776px',
    MOBILE425: '425px',
    MOBILE375: '375px'
};

export const Footer = styled.div`
    margin-top: 40px;
    display: block;
    width: 100%;
    background: #F4F6FB;
    padding: 40px 115px 42px 115px;
    
    @media (max-width: 1440px){
        padding-left: 20px;
        padding-right: 20px;
    }

    @media (max-width: ${MEDIA.LANDSCAPE_PHONE}){
        padding-top: 50px;
        padding-bottom: 50px;
    }
    
    @media (max-width: ${MEDIA.MOBILE375}){
        padding-top: 40px;
        padding-bottom: 60px;
    }
`;

export const Wrap = styled.div`
    max-width: 1300px;
    margin: 0 auto;
`;

export const FooterTop = styled.div`
    width: 100%;
    display: grid;
    grid-template-areas:
      'ServiceLinksBlock PersonalAreaBlock';
    grid-template-columns: 
            48.5% 51.5%;
    grid-template-rows: 150px;
    flex-wrap: wrap;
    
    @media (max-width: 1440px){
      grid-template-areas:
          'ServiceLinksBlock'
          'PersonalAreaBlock';
          
      grid-template-columns: 
            100%;
    }

    @media (max-width: ${breakpoints.mobile}){
      grid-template-rows: 280px;
    }
`;


export const FooterBottom = styled.div`
    width: 100%;
    margin-top: 25px;
    display: grid;
    grid-template-areas:
        'CopyrightBlock SupportBlock';
    grid-template-columns: 
            370px 68%;
            
    @media (max-width: 1164px){
          grid-template-columns: 280px 50%;
    }
    
    @media (max-width: 950px){
          grid-template-columns: 253px 50%;
    }

    @media (max-width: 800px){
          grid-template-columns: 50% 50%;
    }
`;

export const ServiceLinksBlock = styled.div`
    display: flex;
    align-items: center;
    gap: 160px;
    grid-area: ServiceLinksBlock;
    max-width: 490px;
    height: 100%;
    flex-wrap: nowrap;

    @media (max-width: 1440px){       
      max-width: 100%;
      justify-content: space-between;
      gap: unset;
    }
    
    @media (max-width: ${breakpoints.mobile}){
        flex-direction: column;
        align-items: start;
    }
`;


export const PersonalAreaBlock = styled.div`
    margin-left: auto;
    display: flex;
    flex-direction: column;
    max-width: 383px;
    grid-area: PersonalAreaBlock;

    @media (max-width: 1440px){
      margin-left: 0;
      max-width: 100%;
      justify-content: space-between;
      flex-direction: row;
    }
`;

export const CopyrightBlock = styled.div`
    grid-area: CopyrightBlock;
`;

export const SupportBlock = styled.div`
    grid-area: SupportBlock;
    
    @media (max-width: 1440px){
        display: none;
    }
`;

export const CopyrightCompany = styled.p`
    color: ${COLORS.grey};
    ${FONTS.XS};
`;

export const CopyrightText = styled.p`
    color: ${COLORS.grey};
    font-size: 12px;
    line-height: 17px;
    margin-top: 25px;
`;

export const SupportBlockMobile = styled.div`
    display: none;
    grid-area: SupportBlockMobile;
    width: 283px;

    @media (max-width: 1440px){
        display: flex;
        width: 40%;
        margin-bottom: 30px;
        flex-direction: column;
        align-items: start;
    }
  
    @media (max-width: ${breakpoints.mobile}) {
      width: 100%;
    }
`;

export const ButtonsBlockContainer = styled.div`
    width: 383px;

    @media (max-width: ${MEDIA.MOBILE425}){
        width: 100%;
    }
`;

// починить адаптив меньше 500px
